import {styled} from "@mui/material";

export const ActionBarContainer = styled('div')(() => {
    return {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '1.5rem',
        minHeight: '6rem',
    }
});

export const ActionBarStickyContainer = styled(ActionBarContainer)(() => {
    return {
        position: 'sticky',
        top: '60px',
        backgroundColor: '#F1F1FB',
        width: '100%',
        maxWidth: '43rem',
        justifyContent: 'space-between',
        zIndex: 2,

        'transition': 'box-shadow 0.2s ease-in-out'
    }
});

export const ActionBarHeaderTextContainer = styled('div')(() => {
    return {
        display: 'flex',
        gap: '1rem',
        alignItems: 'center',
        width: '100%'
    }
});